import OurPeople from './OurPeople';
export default OurPeople;
